import React from 'react';

type MaterialErrorBannerProps = {
  error: string;
  onDismiss: () => void;
};

export function MaterialErrorBanner({ error, onDismiss }: MaterialErrorBannerProps) {
  return (
    <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm border border-red-200 flex justify-between items-center">
      <span>{error}</span>
      <button type="button" onClick={onDismiss} className="text-red-500 hover:underline">
        Schließen
      </button>
    </div>
  );
}
